import { useQuery, UseQueryOptions } from '@tanstack/react-query';
import {
  getCropDailyGraph,
  IGetCropDailyGraphParams,
  IGetCropDailyGraphResponse,
} from '../../../api/crop-trends/getCropDailyGraph';
import { AxiosError } from 'axios';

interface IUseGetCropDailyGraphParams extends IGetCropDailyGraphParams {
  options?: UseQueryOptions<IGetCropDailyGraphResponse, AxiosError>;
}

export const useGetCropDailyGraph = ({ searchParam, options }: IUseGetCropDailyGraphParams) => {
  return useQuery<IGetCropDailyGraphResponse, AxiosError>(
    [
      'crop-daily-graph',
      searchParam.wholesaleMarketCode,
      searchParam.displayDataType,
      searchParam.largeCategoryCode,
      searchParam.middleCategoryCode,
      searchParam.smallCategoryCode,
    ],
    () => getCropDailyGraph({ searchParam }),
    { ...options },
  );
};
